// removed by extract-text-webpack-plugin
module.exports = {"content":"InvalidResetPassword__content","title":"InvalidResetPassword__title","message":"InvalidResetPassword__message","okButton":"InvalidResetPassword__okButton","growDotQello":"InvalidResetPassword__growDotQello","growDotBlue":"InvalidResetPassword__growDotBlue","growDotGolden":"InvalidResetPassword__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/InvalidResetPassword/InvalidResetPassword.scss
// module id = 1872
// module chunks = 0